import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
  GetRivhitPaymentUrl,
} from "../utils/rivhitPaymentAPI";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [loading, setLoading] =
    useState(false);

  const orderId = sessionStorage.getItem(
    "pendingRivhitOrderId"
  );

  const handleTryAgain = async () => {
    if (!orderId || loading) {
      return;
    }

    try {
      setLoading(true);

      const result =
        await GetRivhitPaymentUrl(orderId);

      const paymentUrl = result?.url;

      if (!paymentUrl) {
        throw new Error(
          result?.message ||
          result?.errorMessage ||
          "לא התקבלה כתובת לדף התשלום"
        );
      }

      window.location.assign(paymentUrl);
    } catch (error) {
      console.error(
        "שגיאה בניסיון התשלום:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "לא ניתן לעבור לתשלום",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "נסי שוב בעוד רגע.",
        confirmButtonText: "אישור",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        component="main"
        dir="rtl"
        sx={{
          mt: 8,
          p: 4,
          textAlign: "center",
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          color="error"
          gutterBottom
        >
          פרטי האשראי לא התקבלו
        </Typography>

        <Typography sx={{ mb: 3 }}>
          לא הצלחנו להשלים את אישור
          כרטיס האשראי. אפשר לנסות שוב.
        </Typography>

        {orderId && (
          <Button
            variant="contained"
            onClick={handleTryAgain}
            disabled={loading}
            sx={{
              ml: 1,
              backgroundColor: "#D81B60",
            }}
          >
            {loading ? (
              <CircularProgress
                size={22}
                color="inherit"
              />
            ) : (
              "ניסיון נוסף"
            )}
          </Button>
        )}

        <Button
          variant="outlined"
          onClick={() => navigate("/")}
        >
          חזרה לדף הבית
        </Button>
      </Box>
    </Container>
  );
};

export default PaymentFailed;